import { createSlice } from "@reduxjs/toolkit";
import { fetchCourses } from "./courseThunk";

const initialState = {
  courses: null,
  listLoading: false,
  error: null,
  success: null,
  errorMessage: "",
};

export const courseSlice = createSlice({
  name: "content",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCourses.pending, (state) => {
      state.listLoading = true;
    });
    builder.addCase(fetchCourses.fulfilled, (state, action) => {
      state.listLoading = false;
      state.error = false;
      state.success = true;
      state.courses = action.payload;
    });
    builder.addCase(fetchCourses.rejected, (state, action) => {
      state.listLoading = false;
      state.error = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default courseSlice.reducer;
